import { ISimpleTab } from '~/src/dash/components/tabs/common';

export interface INavigationConfig {
  tabs: ISimpleTab[];
  defaultState?: {
    activeTabIndex: number;
  };
}

export enum MaxUnderFloorType {
  Percent = 0,
  Currency = 1,
}

export const MaxUnderFloorError = {
  Zero: 'Maximum differences below your floor price permitted for rejected bids to qualify cannot be under 0',
  Fifty:
    'Maximum differences below your floor price permitted for rejected bids to qualify cannot be over 50%',
};
